<template>
  <div class="myCenter">
    <div id="userOpen" style="zIndex:9999">
      <!-- 关闭按钮 -->
      <img class="close" src="@/assets/img/wrong.png" alt="" @click="close">
      <div class="leftBox">
        <div class="profile">
          <div class="img">
            <img v-if="!form.avatar" class="images" src="@/assets/img/defaultProfile.png" alt="">
            <img v-if="form.avatar" class="images" :src="form.avatar" alt="">
          </div>
          <div class="center">
            <span>{{ form.nickName }}</span>
          </div>
        </div>
        <ul class="list">
          <li :class="{ active: tagActive == 1 }" @click="clickTagActive(1)">
            <img src="@/assets/img/userInfoIcon.png" alt=""><span>个人信息</span>
          </li>

          <li :class="{ active: tagActive == 4 }" @click="clickTagActive(4)">
            <img src="@/assets/img/changePassword.png" alt=""><span>安全设置</span>
          </li>
        </ul>
        <div class="button">
          <button @click="logout">退出登录</button>
        </div>
      </div>
      <div class="rightBox">
        <div class="rightBoxScroll">
          <!-- 个人信息 -->
          <div v-show="tagActive == 1" v-if="!isInfoEdit" class="grxx">
            <div class="title">
              <span class="rightCenter">个人信息</span>
            </div>
            <div>
              <!-- 基础信息 -->
              <div v-show="!isInfoEdit" class="information">
                <div class="head">
                  <div class="border" />
                  <h1>基础信息</h1>
                </div>

                <div class="infoBox">
                  <img v-if="!form.avatar" src="@/assets/img/defaultProfile.png" alt="">
                  <img v-if="form.avatar" :src="form.avatar" alt="">
                  <div class="infoBoxLeft">
                    <div class="username">
                      昵称：<span>{{ form.nickname }}</span>
                    </div>
                    <div class="username">
                      真实姓名：<span>{{ form.realname }}</span>
                    </div>
                    <div class="username">
                      医院：<span>{{ filterHospital(form.hospital_id) }}</span>
                    </div>
                  </div>
                  <div class="infoBoxRight">
                    <div class="nickname">
                      手机号：<span>{{ form.phone }}</span>
                    </div>
                    <div class="age">
                      所属分组：<span>{{ filterGroup(form.group_id) }}</span>
                    </div>
                  </div>
                  <div class="informationLeft">
                    <div class="informationLeftBut" @click="infoEdit" v-if="userInfo.hospital.length">
                      编辑信息
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 编辑基础信息 -->
          <div v-show="isInfoEdit" class="deitInformation">
            <h1 @click="cancellation"><img src="@/assets/img/leftGo.png" alt="">编辑信息</h1>
            <div class="deitInfo">
              <el-upload
                ref="iconUpload"
                class="avatar-uploader"
                action="#"
                list-type="picture-card"
                :http-request="uploadFile"
                accept=".jpeg, .jpg, .png"
                :before-upload="beforeAvatarUpload"
                :show-file-list="false"
              >
                <div class="avatar">
                  <img v-if="userInfoForm.avatar" :src="userInfoForm.avatar" alt="">
                  <img
                    v-else
                    src="@/assets/img/defaultProfile.png"
                    alt=""
                  >
                  <div class="mask">
                    <img src="@/assets/img/camera.png" alt="">
                  </div>
                  <!-- <button>选择图片</button> -->
                </div>
              </el-upload>
              <el-form ref="userInfoForm" :model="userInfoForm" :rules="userInfoRules" class="userInfo-form">
                <el-form-item prop="nickname" label="昵称:">
                  <el-input v-model="userInfoForm.nickname" auto-complete="off" placeholder="请输入昵称" />
                </el-form-item>
                <el-form-item prop="realname" label="真实姓名:">
                  <el-input v-model="userInfoForm.realname" auto-complete="off" placeholder="请输入真实姓名" :disabled="true" />
                </el-form-item>
                <el-form-item prop="realname" label="医院:">
                  <el-select v-model="userInfoForm.hospital_id" placeholder="请选择" size="medium" disabled>
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item prop="phone" label="手机号:">
                  <el-input v-model="userInfoForm.phone" auto-complete="off" placeholder="请输入手机号" :disabled="true" />
                </el-form-item>
                <el-form-item prop="realname" label="所属分组:">
                  <el-select v-model="userInfoForm.group_id" collapse-tags placeholder="请选择" size="medium" multiple disabled>
                    <el-option
                      v-for="item in groupOptions"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-form>

              <div class="footer">
                <button class="cancellation" @click="cancellation">取消</button>
                <button class="determine" @click="determine">保存</button>
              </div>
            </div>
          </div>

          <!-- 修改密码 -->
          <div v-show="tagActive == 4" class="xgmm">
            <div class="title">
              <span class="leftBox" /><span class="rightCenter">安全设置</span>
            </div>
            <div class="xgmmBox">
              <div class="body">
                <div class="bodyForm">
                  <el-form ref="xgmmForm" :model="form" class="password-form">
                    <h3>密码：</h3>
                    <el-form-item prop="password">
                      <el-input
                        v-model="password"
                        class="passwordInput"
                        auto-complete="off"
                        type="password"
                      >
                        <i slot="suffix" class="el-input__icon el-icon-edit" @click="modifyShow(1)" />
                      </el-input>
                    </el-form-item>
                    <h3>手机号：</h3>
                    <el-form-item prop="newPassword">
                      <el-input
                        v-model="form.phone"
                        class="passwordInput"
                        auto-complete="off"
                      >
                        <i slot="suffix" class="el-input__icon el-icon-edit" @click="modifyShow(2)" />
                      </el-input>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>
<script>
import { getInfo, modifyUser } from '@/http/index'
import {  upload } from '@/http/index'
// import modifyInfo from '../../personal/child/modify.vue'

// import expert_settled from "./expertSettled";
// import OpinionList from "./opinionList";
// import { getInfo } from '@/api/login'
// import {
//   editorUpImg,
//   updateUserProfile,
//   checkingCode,
//   forgotCode,
//   getForgetPwd
// } from "@/api/dashboard/dashboard.js";

export default {
  name: "MyCenter",
  components: {
  },
  props: ['userInfo'],
  data() {
    return {

      isInstitutionEdit: false,
      isInfoEdit: false,
      tagActive: 1,
      remind: 0,
      type: -1,
      fileList: [],
      defaultProfile: require("@/assets/img/defaultProfile.png"),
      userInfoForm: {
        nickname: "",
        realname: '',
        hospital_id: '',
        phone: '',
        avatar: ''
      },
      form: {},
      options: [],
      groupOptions: [],
      xgmmForm: {
        password: ''

      },
      // 禁止修改密码获取验证码
      passwordProhibit: "",
      // 修改密码获取验证码状态
      passwordGetCode: true,
      xgmmType: 1,
      // 修改密码类名
      xgmmClass: {
        one: "deep", // 'shallow'浅色 'deep'深色
        two: "stepBox", // 'stepBox'浅色 'unStepBox'深色
        three: "shallow", // 'shallow'浅色 'deep'深色
        four: "stepBox", // 'stepBox'浅色 'unStepBox'深色
        five: "shallow" // 'shallow'浅色 'deep'深色
      },
      // 学习记录列表
      trainInfoList: {},
      trainInfoBest: {},
      // 隐藏电话
      userName: "",
      // 基本信息校验
      userInfoRules: {
        nickName: [
          { min: 1, max: 15, message: "昵称长度最大为15", trigger: "blur" }
        ]
      },
      // 修改密码校验
      xgmmRules: {},
      passwordCodeParams: {},
      // 登录表单
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        phone: "",
        code: "",
        onpassword: "",
        unpassword: "",
        provingCode: ""
      },
      // 验证码登录倒计时
      waitTime: 61,
      // 验证码登录文字
      codeBtnWord: "获取短信验证码",
      // 身份验证倒计时
      forgetWaitTime: 61,
      // 身份验证文字
      forgetCodeBtnWord: "获取短信验证码",
      // 修改密码倒计时
      passwordWaitTime: 61,
      // 修改密码文字
      passwordCodeBtnWord: "发送验证码 ",
      trainSwitch: false,
      password: '123456'
    }
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    filterHospital(val) {
      if (this.form.hospital_id) {
        return this.options.find(item => item.id == this.form.hospital_id).title
      } else {
        return ''
      }
    },
    filterGroup(val) {
      return this.groupOptions.map(item => item.title).join(',')
    },
    async getUserInfo() {
      if (localStorage.getItem('hospital_id')) {
        const res = await getInfo({
          token: localStorage.getItem('token'),
          secret: localStorage.getItem('secret'),
          hospital_id: localStorage.getItem('hospital_id')
        })
        if (res.code === 200) {
          this.$store.commit('editUserInfo', res.data);
          this.form = res.data;
          this.form.phone = this.phoneHide();
          this.options = res.data.hospital;
          this.groupOptions = res.data.hospital.find(item => item.id === this.form.hospital_id).group;
          this.form.group_id = [];
          this.groupOptions.map(item => this.form.group_id.push(item.id))
        }
      }else{
        this.form = this.userInfo
        this.form.phone = this.phoneHide();
      }
    },
    // 手机号做脱敏处理
    phoneHide() {
      const reg = /^(1[3-9][0-9])\d{4}(\d{4}$)/; // 定义手机号正则表达式
      var phone = this.form.mobile.replace(reg, '$1****$2');
      return phone; // 输出为131****1234
    },
    // 关闭登录框
    close() {
      // this.log = 0;
      this.remind = 0;
      this.tagActive = 1;
      this.isInfoEdit = false;
      this.$emit('closeCenter')
      this.reset();
    },

    // 清空表单
    reset() {
      this.userInfoForm = {
        nickName: "",
        realname: '',
        hospital_id: '',
        phone: '',
        avatar: ''
      };
    },
    // 编辑基础信息
    infoEdit() {
      this.reset();
      this.$refs["userInfoForm"].resetFields();
      this.$nextTick(() => {
        this.$refs["userInfoForm"].clearValidate();
      });
      this.isInfoEdit = true;
      this.userInfoForm = {
        nickname: this.form.nickname,
        realname: this.form.realname,
        hospital_id: this.form.hospital_id,
        phone: this.form.phone,
        group_id: this.form.group_id,
        avatar: this.form.avatar
      }
    },
    // 退出登录
    logout() {
      this.$emit('logout');
    },

    // 编辑个人信息取消按钮
    cancellation() {
      this.reset();
      this.isInfoEdit = false;
    },

    // 编辑个人信息确定按钮
    determine() {
      this.$refs["userInfoForm"].validate(async(valid) => {
        if (valid) {
          const res = await modifyUser({
            token: localStorage.getItem('token'),
            secret: localStorage.getItem('secret'),
            hospital_id: localStorage.getItem('hospital_id'),
            avatar: this.userInfoForm.avatar,
            nickname: this.userInfoForm.nickname
          })
          if (res.code === 200) {
            this.isInfoEdit = false;
            this.$message.success('修改成功')
            this.getUserInfo();
          }
        }
      });
    },

    // 获取个人信息
    gatInfo() {
      // 获取个人信息
      getInfo()
        .then((res) => {
          this.userInfo = res.user;
          localStorage.setItem("userInfo", JSON.stringify(res.user));
          localStorage.setItem("phonenumber", this.userInfo.phonenumber);
          localStorage.setItem("userID", this.userInfo.userId);
          localStorage.setItem("realName", this.userInfo.realName ? this.userInfo.realName : "");
          localStorage.setItem("examUserName", this.userInfo.realName ? this.userInfo.realName : this.userInfo.userName);
          localStorage.setItem("avatar", this.userInfo.avatar);
          if (this.isClick == '1') {
            this.$router.push({
              path: "/welcome/welcome"
            })
          }
          // this.createSocket();
          const arr = this.userInfo.userName.split("");
          const q = [];
          const h = [];
          arr.forEach((item, index) => {
            if (index < 3) {
              q.push(item);
            }
            if (index > 6) {
              h.push(item);
            }
          });
          this.phoneFront = q.join("");
          this.phoneAfter = h.join("");
        })
        .catch(() => {});
    },

    // tab栏切换
    clickTagActive(val) {
      this.cancellation()
      this.tagActive = val;
      if (val == 4) {
        this.reset();
      }
    },
    // 文件上传
    uploadFile(params) {
      // console.log("uploadFile", params);
      const _file = params.file;
      const isLt2M = _file.size / 1024 / 1024 < 10;

      // 通过 FormData 对象上传文件
      const formData = new FormData();
      formData.append("file", _file);
      formData.append("token", localStorage.getItem('token'));
      formData.append("secret", localStorage.getItem('secret'));
      formData.append("hospital_id", localStorage.getItem('hospital_id'));
      if (!isLt2M) {
        this.$message.error("请上传10M以下的文件");
        return false;
      }
      // 发起请求
      upload(formData).then((response) => {
        if (response.code === 200) {
          this.userInfoForm.avatar = response.data.path;
          this.$message({
            type: "success",
            message: "上传成功！"
          });
        } else {
          this.$message({
            type: "warning",
            message: "上传失败！"
          });
        }
      });
    },
    // 上传之前钩子
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
    },
    modifyShow(e) {
      this.$emit('modify', {
        type: e,
        modifyVisible: true,
        mobile: this.form.mobile,
        phone: this.form.phone
      })
    }
  }
}
</script>
<style lang="scss">
$scale:var(--scale, 1);
/* 个人中心弹框 */
.myCenter{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 90;
    // background: rgba($color: #000000, $alpha: 0.8);
    background: linear-gradient(180deg, rgba(14, 48, 58, 0.8) 0%, rgba(7, 29, 36, 0.8) 100%);
    backdrop-filter: blur(8px);
}
/*提醒弹框*/
#userOpen {
    width: calc(#{$scale} * 1000px);
    height: calc(#{$scale} * 716px);
    background: #FFFFFF;
    border-radius: calc(#{$scale} * 24px);
    position: absolute;
    top: calc(#{$scale} * 100px);
    left: calc(#{$scale} * 460px);
}

#userOpen .close {
    height: calc(#{$scale} * 32px);
    width: calc(#{$scale} * 32px);
    position: absolute;
    top: calc(#{$scale} * 15px);
    right: calc(#{$scale} * 15px);
    cursor: pointer;
}

#userOpen .leftBox {
    height: calc(#{$scale} * 716px);
    width: calc(#{$scale} * 240px);
    display: inline-block;
    background-image: url("~@/assets/img/userLeftBack.png");
    background-size: cover;
    background-repeat: no-repeat;
}

#userOpen .leftBox .profile {
    //height: calc(#{$scale} * 130px);
    width: calc(#{$scale} * 62px);
    margin: 0 auto;
    margin-top: calc(#{$scale} * 70px);
}

#userOpen .leftBox .list {
    height: calc(#{$scale} * 360px);
    width: 100%;
    margin: 0 auto;
    margin-top: calc(#{$scale} * 39px);
    margin-bottom: calc(#{$scale} * 80px);
}

#userOpen .leftBox .list li span {

    line-height: calc(#{$scale} * 72px);
    text-align: center;
    margin-left: calc(#{$scale} * 9px);
}

#userOpen .leftBox .list li {
    height: calc(#{$scale} * 72px);
    width: 100%;
    margin: 0 auto;
    list-style: none;
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: calc(#{$scale} * 72px);
    text-align: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

}

#userOpen .leftBox .list li:hover {
    cursor: pointer;
    background: #DD594A;
}

#userOpen .leftBox .list li img {
    vertical-align: text-top;
    height: calc(#{$scale} * 24px);
    width: auto;
}

#userOpen .leftBox .list .active {
    height: calc(#{$scale} * 72px);
    width: 100%;
    margin: 0 auto;
    background: #DD594A;
    list-style: none;
}

#userOpen .leftBox .profile .img {
    height: calc(#{$scale} * 62px);
    width: calc(#{$scale} * 62px);
    position: relative;
}

#userOpen .leftBox .profile .img img {
    height: 100%;
    width: 100%;
    border-radius: 50%;
    display: block;
    margin-bottom: calc(#{$scale} * 8px);
}

#userOpen .leftBox .profile .img .icon {
    height: calc(#{$scale} * 24px);
    width: calc(#{$scale} * 24px);
    position: absolute;
    right: 0;
    bottom: 0;
}

#userOpen .leftBox .profile .center {
    text-align: center;
    width: calc(#{$scale} * 130px);
    margin-top: calc(#{$scale} * 8px);
    margin-left: calc(#{$scale} * -30px);
    font-size: calc(#{$scale} * 16px);
    line-height: calc(#{$scale} * 22px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

#userOpen .leftBox .button {
    width: 100%;
    height: calc(#{$scale} * 44px);
    text-align: center;
    display: flex;
    justify-content: center;
}

#userOpen .leftBox button {
    width: calc(#{$scale} * 110px);
    height: calc(#{$scale} * 44px);
    background: #DD594A;
    //box-shadow: inset calc(#{$scale} * 0px) calc(#{$scale} * 0px) calc(#{$scale} * 7px) calc(#{$scale} * 1px) rgba(129, 255, 249, 0.72);
    border-radius: calc(#{$scale} * 22px);
    backdrop-filter: blur(calc(#{$scale} * 0px));
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: calc(#{$scale} * 20px);
    border: calc(#{$scale} * 0px);
}

#userOpen .leftBox button:hover {
    cursor: pointer;
}

#userOpen .rightBox {
    height: calc(#{$scale} * 716px);
    width: calc(#{$scale} * 760px);
    padding: calc(#{$scale} * 18px) calc(#{$scale} * 0px) calc(#{$scale} * 20px) calc(#{$scale} * 16px);
    float: right;
    border-radius: calc(#{$scale} * 0px) calc(#{$scale} * 24px) calc(#{$scale} * 24px) calc(#{$scale} * 0px);
    overflow: hidden;
}

#userOpen .rightBox .rightBoxScroll {
    height: 100%;
    width: 100%;
    padding-right: calc(#{$scale} * 24px);
    padding-bottom: calc(#{$scale} * 60px);
    overflow-y: auto;
}

/* 个人信息页面 */
#userOpen .rightBox .grxx {
    height: 100%;
    width: 100%;
    // overflow: auto;
}

#userOpen .rightBox .grxx .title {
    height: calc(#{$scale} * 33px);
    width: calc(#{$scale} * 118px);
    display: flex;
    display: flex;
    flex-direction: row;
    align-items: center;

}

#userOpen .rightBox .grxx .title .leftBox {
    height: calc(#{$scale} * 29px);
    width: calc(#{$scale} * 6px);
    margin-top: calc(#{$scale} * 3px);
    background-color: #DD594A;
    margin-right: calc(#{$scale} * 10px);

}

#userOpen .rightBox .grxx .title .rightCenter {

    height: calc(#{$scale} * 33px);
    width: calc(#{$scale} * 96px);
    font-weight: 600;
    font-size: calc(#{$scale} * 18px);
    color: #262626;
    line-height: calc(#{$scale} * 33px);
    font-family: PingFangSC-Medium, PingFang SC;
}

#userOpen .rightBox .grxx .title .backLeft {
    display: inline-block;
    margin-top: calc(#{$scale} * 6px);
    width: calc(#{$scale} * 18px);
    height: calc(#{$scale} * 22px);
    background-image: url("~@/assets/img/right.png");
    background-size: calc(#{$scale} * 18px) calc(#{$scale} * 22px);
    background-repeat: no-repeat;
    transform: rotate(180deg);
    vertical-align: sub;

}

#userOpen .rightBox .grxx .information {
    width: 100%;
    height: calc(#{$scale} * 200px);
    padding: calc(#{$scale} * 12px);
    background: #F7FAFA;
    border-radius: calc(#{$scale} * 12px);
    margin-top: calc(#{$scale} * 15px);
    position: relative;
}

#userOpen .rightBox .grxx .information .head {
    display: flex;
    align-items: center;
}

#userOpen .rightBox .grxx .information .border {
    width: calc(#{$scale} * 4px);
    height: calc(#{$scale} * 18px);
    background-color: #DD594A;
}

#userOpen .rightBox .grxx .information h1 {
    /* border-left: calc(#{$scale} * 4px) solid #DD594A; */
    margin-left: calc(#{$scale} * 12px);
    line-height: calc(#{$scale} * 32px);
    height: calc(#{$scale} * 32px);
    font-weight: 500;
    font-size: calc(#{$scale} * 16px);
    color: #262626;
    font-family: PingFangSC-Medium, PingFang SC;
}

#userOpen .rightBox .grxx .infoBox {
    height: calc(#{$scale} * 120px);
    width: 100%;
    margin-top: calc(#{$scale} * 15px);
    display: flex;
    align-items: center;
}

#userOpen .rightBox .grxx .infoBox img {
    height: calc(#{$scale} * 48px);
    width: calc(#{$scale} * 48px);
    border-radius: calc(#{$scale} * 50px);
}

#userOpen .rightBox .grxx .infoBox .infoBoxLeft {
    width: calc(#{$scale} * 310px);
    height: 100%;
    display: inline-block;
    margin-left: calc(#{$scale} * 16px);
    /* padding: calc(#{$scale} * 16px) 0; */
    overflow: hidden;
}

#userOpen .rightBox .grxx .infoBox .infoBoxLeft span {
    margin-left: calc(#{$scale} * 10px);
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
}

#userOpen .rightBox .grxx .infoBox .infoBoxLeft .username {
    height: calc(#{$scale} * 22px);
    margin-bottom: calc(#{$scale} * 28px);
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}

#userOpen .rightBox .grxx .infoBox .infoBoxLeft .gender {
    height: calc(#{$scale} * 22px);
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}

#userOpen .rightBox .grxx .infoBox .infoBoxRight {
    width: calc(#{$scale} * 310px);
    height: 100%;
    display: inline-block;
    /* padding: calc(#{$scale} * 16px) 0; */
    overflow: hidden;
}

#userOpen .rightBox .grxx .infoBox .infoBoxRight span {
    margin-left: calc(#{$scale} * 10px);
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
}

#userOpen .rightBox .grxx .infoBox .infoBoxRight .nickname {
    height: calc(#{$scale} * 22px);
    margin-bottom: calc(#{$scale} * 24px);
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}

#userOpen .rightBox .grxx .infoBox .infoBoxRight .age {
    height: calc(#{$scale} * 22px);
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}

#userOpen .rightBox .grxx .infoBox .informationLeft {
    position: absolute;
    top: calc(#{$scale} * 12px);
    right: calc(#{$scale} * 12px);
    display: inline-block;
    overflow: hidden;
    .informationLeftBut {
        width: calc(#{$scale} * 100px);
        height: calc(#{$scale} * 36px);
        line-height: calc(#{$scale} * 36px);
        border-radius: calc(#{$scale} * 18px);
        border: calc(#{$scale} * 1px) solid #DD594A;
        background: transparent;
        font-size: calc(#{$scale} * 14px);
        color: #DD594A;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        text-align: center;
    }
}

#userOpen .rightBox .grxx .infoBox button:hover {
    cursor: pointer;
}

/* 基本信息编辑状态 */
#userOpen .rightBox .deitInformation {
    width: 100%;
    border-radius: calc(#{$scale} * 16px);
}

#userOpen .rightBox .deitInformation h1 {
    margin-bottom: calc(#{$scale} * 12px);
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: calc(#{$scale} * 24px);
    color: #262626;
    display: flex;
    align-items: center;
}

#userOpen .rightBox .deitInformation h1:hover {
    cursor: pointer;
}

#userOpen .rightBox .deitInformation h1 img {
    height: calc(#{$scale} * 18px);
}

#userOpen .rightBox .deitInformation .deitInfo {
    padding: calc(#{$scale} * 0px) calc(#{$scale} * 50px);
}

#userOpen .rightBox .deitInformation .deitInfo .avatar-uploader,
.avatar-uploader .el-upload--picture-card {
    display: flex;
    justify-content: center;
    height: calc(#{$scale} * 80px);
    margin-bottom: calc(#{$scale} * 40px);
    border: 0;
    line-height: 0;
}

#userOpen .rightBox .deitInformation .deitInfo .avatar {
    width: calc(#{$scale} * 80px);
    height: calc(#{$scale} * 80px);
    margin-bottom: calc(#{$scale} * 22px);
    position: relative;
}

#userOpen .rightBox .deitInformation .deitInfo .avatar img {
  width: calc(#{$scale} * 80px);
  height: calc(#{$scale} * 80px);
    border-radius: 50%;
}

#userOpen .rightBox .deitInformation .deitInfo .avatar .mask {
    width: calc(#{$scale} * 80px);
    height: calc(#{$scale} * 80px);
    background: rgba(0, 0, 0, 0.4);
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

#userOpen .rightBox .deitInformation .deitInfo .avatar .mask img {
    width: calc(#{$scale} * 35px);
    height: calc(#{$scale} * 30px);
    border-radius: 0;
}

#userOpen .rightBox .deitInformation .deitInfo .avatar button {
    height: calc(#{$scale} * 100px);
    margin-bottom: calc(#{$scale} * 22px);
    border: 0;
    background-color: #ffffff00;
    margin-left: calc(#{$scale} * 16px);
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #028B73;
    line-height: calc(#{$scale} * 22px);
}

/* #userOpen .rightBox .grxx .deitInformation .deitInfo .infoLeftBox .infoUserName h3 {
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: calc(#{$scale} * 22px);
    margin-bottom: calc(#{$scale} * 12px);
    margin-top: calc(#{$scale} * 22px);
  } */
  #userOpen .rightBox .deitInformation .deitInfo .userInfo-form{
    display: flex;
    flex-direction: column;
    align-items: center;
    .el-form-item{
        display: flex;
        flex-direction:row ;
        margin-bottom: calc(#{$scale} * 22px);
        .el-form-item__content{
            font-size:  calc(#{$scale} * 16px);
            line-height: calc(#{$scale} * 36px);
            height: calc(#{$scale} * 36px);
        }
        .el-form-item__label{
            padding:0 calc(#{$scale} * 12px) 0 0;
            font-size: calc(#{$scale} * 16px);
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: calc(#{$scale} * 48px);
            height: calc(#{$scale} * 48px);
            width: calc(#{$scale} * 80px);
        }
        .el-input--medium, .el-input{
            height: calc(#{$scale} * 50px);
            width: 100%;
            border-radius: calc(#{$scale} * 8px);
            background: #FFFFFF;
            /* border: calc(#{$scale} * 1px) solid #E0E0E0; */
            font-size: calc(#{$scale} * 16px);
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #262626;

        }
        .el-input__inner{
            border: calc(#{$scale} * 1px) solid #E0E0E0;
            /* background: #FFFFFF; */
            border-radius: calc(#{$scale} * 8px);
            height: calc(#{$scale} * 48px);
            width: calc(#{$scale} * 220px);
            line-height: calc(#{$scale} * 48px);
            padding: 0 calc(#{$scale} * 15px);

        }
    }
  }

#userOpen .rightBox .deitInformation .deitInfo .userInfo-form .el-input__inner {

}

#userOpen .rightBox .deitInformation .deitInfo .userInfo-form .button {
    width: 100%;
    display: flex;
    //justify-content: space-between;
}

#userOpen .rightBox .deitInformation .deitInfo .userInfo-form .button button {
    width: calc(#{$scale} * 100px);
    height: calc(#{$scale} * 40px);
    background: #FFFFFF;
    border-radius: calc(#{$scale} * 8px);
    border: calc(#{$scale} * 1px) solid #E0E0E0;
    /* margin-right: calc(#{$scale} * 24px); */
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
    line-height: calc(#{$scale} * 22px);
    margin-right: calc(#{$scale} * 20px);
}

#userOpen .rightBox .deitInformation .deitInfo .userInfo-form .button button:hover {
    cursor: pointer;
}

#userOpen .rightBox .deitInformation .deitInfo .userInfo-form .button .selectButton {
    width: calc(#{$scale} * 100px);
    height: calc(#{$scale} * 40px);
    background: #DD594A;
    border-radius: calc(#{$scale} * 8px);
    border: calc(#{$scale} * 0px);
    margin-right: calc(#{$scale} * 20px);
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: calc(#{$scale} * 22px);

}

#userOpen .rightBox .deitInformation .deitInfo .footer {
    margin-top: calc(#{$scale} * 102px);
    padding: 0 calc(#{$scale} * 28px);
    width: 100%;
    height: calc(#{$scale} * 48px);
    display: flex;
    justify-content: space-between;
}

#userOpen .rightBox .deitInformation .deitInfo .footer .cancellation {
    width: calc(#{$scale} * 100px);
    height: calc(#{$scale} * 40px);
    background: #FFFFFF;
    border-radius: calc(#{$scale} * 24px);
    border: calc(#{$scale} * 1px) solid #E0E0E0;
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: calc(#{$scale} * 28px);
}

#userOpen .rightBox .deitInformation .deitInfo .footer .determine {
    width: calc(#{$scale} * 100px);
    height: calc(#{$scale} * 40px);
    background: #DD594A;
    border-radius: calc(#{$scale} * 24px);
    border: 0;
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: calc(#{$scale} * 28px);
}

#userOpen .rightBox .deitInformation .deitInfo .footer button:hover {
    cursor: pointer;
}

/* 机构认证 */
#userOpen .rightBox .grxx .institution {
    width: 100%;
    /* height: calc(#{$scale} * 166px); */
    background: #F7FAFA;
    border-radius: calc(#{$scale} * 16px);
    margin-top: calc(#{$scale} * 20px);
    margin-bottom: calc(#{$scale} * 20px);
}

#userOpen .rightBox .grxx .institution .institutionLeft {
    padding: calc(#{$scale} * 15px) calc(#{$scale} * 0px) calc(#{$scale} * 18px) calc(#{$scale} * 12px);
    display: inline-block;
}

#userOpen .rightBox .grxx .institution .head {
    display: flex;
    align-items: center;
    margin-bottom: calc(#{$scale} * 8px);
}

#userOpen .rightBox .grxx .institution .border {
    width: calc(#{$scale} * 4px);
    height: calc(#{$scale} * 18px);
    background-color: #DD594A;
}

#userOpen .rightBox .grxx .institution .institutionLeft h1 {
    /* border-left: calc(#{$scale} * 4px) solid #DD594A; */
    margin-left: calc(#{$scale} * 12px);
    height: calc(#{$scale} * 32px);
    line-height: calc(#{$scale} * 32px);
    font-weight: 500;
    font-size: calc(#{$scale} * 16px);
    color: #262626;
    font-family: PingFangSC-Medium, PingFang SC;
}

#userOpen .rightBox .grxx .institution .institutionLeft ul {
    padding-left: calc(#{$scale} * 28px);
}

#userOpen .rightBox .grxx .institution .institutionLeft li {
    margin-bottom: calc(#{$scale} * 12px);
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}

#userOpen .rightBox .grxx .institution .institutionRight {
    float: right;
}

#userOpen .rightBox .grxx .institution .institutionRight img {
    display: block;
    margin: calc(#{$scale} * 28px) calc(#{$scale} * 40px) calc(#{$scale} * 6px) calc(#{$scale} * 28px);
    width: calc(#{$scale} * 148px);
    height: calc(#{$scale} * 110px);
}

#userOpen .rightBox .grxx .institution .institutionRight button {
    display: block;
    width: calc(#{$scale} * 144px);
    height: calc(#{$scale} * 48px);
    background: linear-gradient(180deg, #05BFAB 0%, #028B73 100%);
    border: 0;
    border-radius: calc(#{$scale} * 8px);
    font-size: calc(#{$scale} * 20px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
}

/* 机构认证编辑状态 */
#userOpen .rightBox .grxx .editInstitution {
    width: 100%;
    /* height: calc(#{$scale} * 252px); */
    padding: calc(#{$scale} * 15px) 0 calc(#{$scale} * 15px) calc(#{$scale} * 12px);
    background: #F8F9FB;
    border-radius: calc(#{$scale} * 16px);
    margin-top: calc(#{$scale} * 24px);
  h1{
    height: calc(#{$scale} * 32px);
    line-height: calc(#{$scale} * 32px);
    font-weight: 500;
    font-size: calc(#{$scale} * 16px);
    color: #262626;
  }
}

/* 学习记录页面 */
#userOpen .rightBox .xxjl {
    height: 100%;
    width: calc(#{$scale} * 720px);
    overflow: auto;
}

#userOpen .rightBox .xxjl .title {
    height: calc(#{$scale} * 33px);
    width: calc(#{$scale} * 110px);
    display: flex;
    flex-direction: row;
    align-items: center;
}

#userOpen .rightBox .xxjl .title .leftBox {
    height: calc(#{$scale} * 20px);
    width: calc(#{$scale} * 4px);
    background-color: #028B73;
    margin-right: calc(#{$scale} * 10px);
}

#userOpen .rightBox .xxjl .title .rightCenter {
    float: right;
    height: calc(#{$scale} * 33px);
    width: calc(#{$scale} * 96px);
    font-size: calc(#{$scale} * 16px);
    line-height: calc(#{$scale} * 33px);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262626;
}

#userOpen .rightBox .xxjl .headerTitle {
    margin-top: calc(#{$scale} * 24px);
    height: calc(#{$scale} * 111px);
    width: 98%;
    background: rgba(198, 231, 226, 0.3);
    border-radius: calc(#{$scale} * 16px);
    border: calc(#{$scale} * 1px) solid rgba(97, 190, 182, 0.3);
    position: relative;
}

#userOpen .rightBox .xxjl .headerTitle .rightTop {
    height: calc(#{$scale} * 86px);
    width: calc(#{$scale} * 86px);
    padding-top: calc(#{$scale} * 12px);
    padding-right: calc(#{$scale} * 12px);
    background-image: url("~@/assets/img/rightTop.png");
    background-size: 100%;
    position: absolute;
    top: calc(#{$scale} * -13px);
    right: calc(#{$scale} * -12px);
    display: flex;
    justify-content: center;
}

#userOpen .rightBox .xxjl .headerTitle .rightTop .center {
    height: calc(#{$scale} * 56px);
    width: calc(#{$scale} * 45px);
    margin-top: calc(#{$scale} * 3px);
    /* margin-left: calc(#{$scale} * 22px); */
    display: flex;
    justify-content: center;

}

#userOpen .rightBox .xxjl .headerTitle .rightTop .center h1 {
    width: calc(#{$scale} * 28px);
    height: calc(#{$scale} * 56px);
    font-size: calc(#{$scale} * 40px);
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #028B73;
    line-height: calc(#{$scale} * 56px);
    display: inline-block;
}

#userOpen .rightBox .xxjl .headerTitle .rightTop .center span {
    width: calc(#{$scale} * 17px);
    height: calc(#{$scale} * 40px);
    font-size: calc(#{$scale} * 28px);
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #028B73;
    line-height: calc(#{$scale} * 40px);
    float: right;
}

#userOpen .rightBox .xxjl .headerTitle h1 {
    font-size: calc(#{$scale} * 32px);
    font-family: DINOT-Medium, DINOT;
    font-weight: 500;
    color: #028B73;
    line-height: calc(#{$scale} * 41px);
    text-align: center;
}

#userOpen .rightBox .xxjl .headerTitle p {
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: calc(#{$scale} * 22px);
    text-align: center;
}

#userOpen .rightBox .xxjl .headerTitle .left {
    height: 100%;
    width: 49%;
    display: inline-block;
}

#userOpen .rightBox .xxjl .headerTitle .left .xxcs {
    height: calc(#{$scale} * 63px);
    width: calc(#{$scale} * 92px);
    margin: 0 auto;
    margin-top: calc(#{$scale} * 24px);
}

#userOpen .rightBox .xxjl .headerTitle .right {
    height: 100%;
    width: 49%;
    display: inline-block;
}

#userOpen .rightBox .xxjl .headerTitle .right .zjcj {
    height: calc(#{$scale} * 63px);
    width: calc(#{$scale} * 92px);
    margin: 0 auto;
    margin-top: calc(#{$scale} * 24px);
}

#userOpen .rightBox .xxjl .xxjlList {
    margin-top: calc(#{$scale} * 16px);
    width: 98%;
    position: relative;
}

#userOpen .rightBox .xxjl .xxjlList .isRead {
    width: calc(#{$scale} * 8px);
    height: calc(#{$scale} * 8px);
    background: #E42F2F;
    box-shadow: calc(#{$scale} * 0px) calc(#{$scale} * 2px) calc(#{$scale} * 4px) calc(#{$scale} * 0px) rgba(182, 182, 182, 0.3);
    border: calc(#{$scale} * 2px) solid #FFFFFF;
    border-radius: 50%;
    position: absolute;
    top: calc(#{$scale} * 12px);
    left: calc(#{$scale} * 12px);
}

#userOpen .rightBox .xxjl .xxjlList:last-child {
    margin-bottom: calc(#{$scale} * 16px);
}

#userOpen .rightBox .xxjl .xxjlList .item {
    height: calc(#{$scale} * 120px);
    width: 100%;
    margin-top: calc(#{$scale} * 16px);
    background: #F8F9FB;
    border-radius: calc(#{$scale} * 16px);
    padding: calc(#{$scale} * 17px) calc(#{$scale} * 40px) calc(#{$scale} * 17px) calc(#{$scale} * 37px);
    display: flex;
    justify-content: space-between;
}

#userOpen .rightBox .xxjl .xxjlList .item .left .center {
    height: calc(#{$scale} * 86px);
    width: calc(#{$scale} * 86px);
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url("~@/assets/img/scoreBack.png");
    background-size: 100%;
}

#userOpen .rightBox .xxjl .xxjlList .item .left .center h1 {
    width: calc(#{$scale} * 28px);
    height: calc(#{$scale} * 56px);
    font-size: calc(#{$scale} * 40px);
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #028B73;
    line-height: calc(#{$scale} * 56px);
    display: inline-block;
}

#userOpen .rightBox .xxjl .xxjlList .item .left .center span {
    width: calc(#{$scale} * 17px);
    height: calc(#{$scale} * 40px);
    font-size: calc(#{$scale} * 28px);
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #028B73;
    line-height: calc(#{$scale} * 40px);
    float: right;
}

#userOpen .rightBox .xxjl .xxjlList .item .left .dept {
    height: calc(#{$scale} * 24px);
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: calc(#{$scale} * -14px);
}

#userOpen .rightBox .xxjl .xxjlList .item .left .dept span {
    height: calc(#{$scale} * 24px);
    min-width: calc(#{$scale} * 40px);
    background: #028B73;
    border-radius: calc(#{$scale} * 12px);
    border: calc(#{$scale} * 2px) solid #F8F9FB;
    font-size: calc(#{$scale} * 13px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: calc(#{$scale} * 21px);
    text-align: center;
    padding: calc(#{$scale} * 0px) calc(#{$scale} * 8px);
}

#userOpen .rightBox .xxjl .xxjlList .item .centerBox {
    height: calc(#{$scale} * 75px);
    width: calc(#{$scale} * 628px);
    margin-top: calc(#{$scale} * 11px);
    flex: 1;
}

#userOpen .rightBox .xxjl .xxjlList .item .centerBox p {
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
    line-height: calc(#{$scale} * 22px);
    margin-bottom: calc(#{$scale} * 9px);
    white-space: nowrap;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
}

#userOpen .rightBox .xxjl .xxjlList .item .centerBox .score {
    height: calc(#{$scale} * 41px);
    width: calc(#{$scale} * 182px);
    float: left;
}

#userOpen .rightBox .xxjl .xxjlList .item .centerBox .score .text1 {
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
    line-height: calc(#{$scale} * 41px);
    float: left;
}

#userOpen .rightBox .xxjl .xxjlList .item .centerBox .score .text2 {
    font-size: calc(#{$scale} * 32px);
    font-family: DINOT-Medium, DINOT;
    font-weight: 500;
    line-height: calc(#{$scale} * 41px);
    color: #028B73;
}

#userOpen .rightBox .xxjl .xxjlList .item .centerBox .duration {
    height: calc(#{$scale} * 41px);
    width: calc(#{$scale} * 200px);
    float: left;
}

#userOpen .rightBox .xxjl .xxjlList .item .centerBox .duration .text1 {
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
    line-height: calc(#{$scale} * 41px);
    float: left;
}

#userOpen .rightBox .xxjl .xxjlList .item .centerBox .duration .text2 {
    font-size: calc(#{$scale} * 32px);
    font-family: DINOT-Medium, DINOT;
    font-weight: 500;
    line-height: calc(#{$scale} * 41px);
    color: #028B73;
}

#userOpen .rightBox .xxjl .xxjlList .item .right {
    height: calc(#{$scale} * 67px);
    /* width: calc(#{$scale} * 160px); */
    margin-top: calc(#{$scale} * 11px);
}

#userOpen .rightBox .xxjl .xxjlList .item .right p {
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}

#userOpen .rightBox .xxjl .xxjlList .item .right button {
    border: 0;
    background-color: #00000000;
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2DBBAB;
    float: right;
    margin-top: calc(#{$scale} * 23px);
}

#userOpen .rightBox .xxjl .xxjlList .item .right button:hover {
    cursor: pointer;
}

/* 考试记录页面 */
#userOpen .rightBox .ksjl {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

#userOpen .rightBox .ksjl .center {
    height: calc(#{$scale} * 550px);
    width: calc(#{$scale} * 400px);
}

#userOpen .rightBox .ksjl img {
    height: calc(#{$scale} * 400px);
    width: calc(#{$scale} * 400px);
}

#userOpen .rightBox .ksjl h1 {
    padding-left: calc(#{$scale} * 70px);
    color: #262626;
}

/* 修改密码页面 */
#userOpen .rightBox .xgmm {
    height: 100%;
    width: 100%;

}

#userOpen .rightBox .xgmm .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: calc(#{$scale} * 33px);
    width: calc(#{$scale} * 110px);
}

#userOpen .rightBox .xgmm .title .leftBox {
    height: calc(#{$scale} * 20px);
    width: calc(#{$scale} * 4px);
    background-color: #028B73;
    margin-right: calc(#{$scale} * 10px);
}

#userOpen .rightBox .xgmm .title .rightCenter {
    float: right;
    height: calc(#{$scale} * 33px);
    width: calc(#{$scale} * 96px);
    font-size: calc(#{$scale} * 16px);
    line-height: calc(#{$scale} * 33px);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262626;
}

#userOpen .rightBox .xgmm .xgmmBox {
    width: calc(#{$scale} * 730px);
    height: calc(#{$scale} * 528px);
    background: #F8F9FB;
    border-radius: calc(#{$scale} * 16px);
    margin-top: calc(#{$scale} * 37px);
}

#userOpen .rightBox .xgmm .xgmmBox .header {
    width: calc(#{$scale} * 730px);
    height: calc(#{$scale} * 146px);
    background: rgba(198, 231, 226, 0.3);
    border-radius: calc(#{$scale} * 12px) calc(#{$scale} * 12px) calc(#{$scale} * 0px) calc(#{$scale} * 0px);
    padding-top: calc(#{$scale} * 33px);
    display: flex;
    justify-content: center;
}

#userOpen .rightBox .xgmm .xgmmBox .mainBox {
    display: flex;
    align-items: center;
    /* width: calc(#{$scale} * 528px); */
    height: calc(#{$scale} * 83px);
    margin: 0 auto;
    .mainBoxImgStyle{
        margin-top: calc(#{$scale} * 14px)

    }
}

#userOpen .rightBox .xgmm .xgmmBox .mainBox .shallow {
    /* width: calc(#{$scale} * 64px); */
    height: calc(#{$scale} * 83px);
    display: inline-block;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

#userOpen .rightBox .xgmm .xgmmBox .mainBox .shallow div {
    width: calc(#{$scale} * 50px);
    height: calc(#{$scale} * 50px);
    margin-left: calc(#{$scale} * 7px);
    padding: 0 calc(#{$scale} * 14px);
    text-align: center;
    line-height: calc(#{$scale} * 50px);
    font-size: calc(#{$scale} * 20px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    background-image: url("~@/assets/img/stepBack.png");
    background-size: 100%;
}

#userOpen .rightBox .xgmm .xgmmBox .mainBox .shallow h4 {
    margin-top: calc(#{$scale} * 11px);
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262626;
    display: inline-block;
}

#userOpen .rightBox .xgmm .xgmmBox .mainBox .deep {
    /* width: calc(#{$scale} * 64px); */
    height: calc(#{$scale} * 83px);
    display: flex;
    flex-direction: column;
    justify-content: center;
}

#userOpen .rightBox .xgmm .xgmmBox .mainBox .deep div {
    width: calc(#{$scale} * 50px);
    height: calc(#{$scale} * 50px);
    margin-left: calc(#{$scale} * 7px);
    padding: 0 calc(#{$scale} * 14px);
    text-align: center;
    line-height: calc(#{$scale} * 50px);
    font-size: calc(#{$scale} * 20px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    background-image: url("~@/assets/img/unstepBack.png");
    background-size: 100%;
}

#userOpen .rightBox .xgmm .xgmmBox .mainBox .deep h4 {
    margin-top: calc(#{$scale} * 11px);
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #028B73;
    display: inline-block;
}

#userOpen .rightBox .xgmm .xgmmBox .mainBox .stepBox {
    width: calc(#{$scale} * 88px);
    height: calc(#{$scale} * 8px);
    display: inline-block;
    margin: 0 calc(#{$scale} * 40px);
    background-image: url("~@/assets/img/connectShallow.png");
    background-size: 100%;
}

#userOpen .rightBox .xgmm .xgmmBox .mainBox .unStepBox {
    width: calc(#{$scale} * 88px);
    height: calc(#{$scale} * 8px);
    display: inline-block;
    /* margin: 0 calc(#{$scale} * 40px) calc(#{$scale} * 45px) calc(#{$scale} * 40px); */
    margin: 0 calc(#{$scale} * 40px);
    background-image: url("~@/assets/img/unConnectShallow.png");
}

#userOpen .rightBox .xgmm .xgmmBox .body {
    width: 100%;
    height: calc(#{$scale} * 382px);
    border-radius: calc(#{$scale} * 0px) calc(#{$scale} * 0px) calc(#{$scale} * 12px) calc(#{$scale} * 12px);
    padding-top: calc(#{$scale} * 48px);
}
#userOpen .rightBox .xgmm .xgmmBox .body .passwordButSure{
    margin-top: calc(#{$scale} * 150px)

}
#userOpen .rightBox .xgmm .xgmmBox .body .passwordButBack{
    margin-top: calc(#{$scale} * 62px)

}

#userOpen .rightBox .xgmm .xgmmBox .bodyText {
    height: calc(#{$scale} * 60px);
    width: calc(#{$scale} * 540px);
    margin: 0 auto;
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262626;
    line-height: calc(#{$scale} * 30px);
}

#userOpen .rightBox .xgmm .xgmmBox .body .bodyText span {
    color: #fe6363;
}

#userOpen .rightBox .xgmm .xgmmBox .bodyForm {
    height: calc(#{$scale} * 82px);
    width: calc(#{$scale} * 400px);
    margin: 0 auto;
    margin-top: calc(#{$scale} * 48px);
}

#userOpen .rightBox .xgmm .xgmmBox .bodyForm h3 {
    margin-bottom: calc(#{$scale} * 12px);
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: calc(#{$scale} * 22px);
}

.password-form {
    .el-input {
        height: calc(#{$scale} * 50px);
        line-height: calc(#{$scale} * 50px);
        width: calc(#{$scale} * 400px);
        border-radius: calc(#{$scale} * 8px);
        background: #FFFFFF;
        border: calc(#{$scale} * 1px) solid #E0E0E0;
        font-size: calc(#{$scale} * 16px);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        display: flex;
        a {
            font-size: calc(#{$scale} * 16px);
            font-family: PingFangSC-Regular, PingFang SC;
            color: #028B73;
            margin-top: calc(#{$scale} * 5px);
            margin-right: calc(#{$scale} * 5px);
            display: inline-block;
            height: calc(#{$scale} * 36px);
            line-height: calc(#{$scale} * 36px);
        }
    }
}

.passwordInput {
    display: flex;
    align-items: center;
    .el-input__suffix{
        display: flex;
        align-items: center;
        right:calc(#{$scale} * 5px);
        .el-input__suffix-inner{
            height: calc(#{$scale} * 48px);
            line-height: calc(#{$scale} * 48px);

        }
    }
    .el-input__inner {
        border: calc(#{$scale} * 0px) !important;
        margin-top: calc(#{$scale} * 5px);
        height: calc(#{$scale} * 40px) !important;
        line-height: calc(#{$scale} * 40px) !important;
        padding: 0 calc(#{$scale} * 15px) !important;
    }
}

.password-form .el-input

.password-form .el-input .prohibit {
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    pointer-events: none;
    color: #868686;
}

#userOpen .rightBox .xgmm .xgmmBox .body .bodyComplete {
    width: calc(#{$scale} * 136px);
    height: calc(#{$scale} * 120px);
    margin: 0 auto;
    margin-top: calc(#{$scale} * 40px);
}

#userOpen .rightBox .xgmm .xgmmBox .body .bodyComplete img {
    width: calc(#{$scale} * 96px);
    height: calc(#{$scale} * 96px);
    margin: 0 auto;
    display: block;
}

#userOpen .rightBox .xgmm .xgmmBox .body .bodyComplete h1 {
    text-align: center;
    font-size: calc(#{$scale} * 20px);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262626;
    margin-top: calc(#{$scale} * 12px);
}

#userOpen .rightBox .xgmm .xgmmBox button {
    width: calc(#{$scale} * 144px);
    height: calc(#{$scale} * 48px);
    background: linear-gradient(180deg, #05BFAB 0%, #028B73 100%);
    font-size: calc(#{$scale} * 20px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: calc(#{$scale} * 28px);
    margin: 0 auto;
    margin-top: calc(#{$scale} * 48px);
    display: block;
    border: 0;
    border-radius: calc(#{$scale} * 8px);
}

#userOpen .rightBox .xgmm .xgmmBox button:hover {
    cursor: pointer;
}

 #userOpen .rightBox  .train{
    padding: calc(#{$scale} * 20px) calc(#{$scale} * 77px) calc(#{$scale} * 26px) calc(#{$scale} * 24px);
    width: 100%;
    height: calc(#{$scale} * 110px);
    background: #F8F9FB;
    border-radius: calc(#{$scale} * 16px);
    /* margin-top: calc(#{$scale} * 10px); */
  }

  #userOpen .rightBox  .train .trainLeft{
    /* padding: calc(#{$scale} * 19px) calc(#{$scale} * 0px) calc(#{$scale} * 31px) calc(#{$scale} * 24px); */
    display: inline-block;
  }
  #userOpen .rightBox  .train .trainLeft .head{
    display: flex;
    align-items: center;
    margin-bottom: calc(#{$scale} * 10px);
   }
  #userOpen .rightBox  .train .trainLeft .border{
   width: calc(#{$scale} * 4px);
   height: calc(#{$scale} * 18px);
   background-color: #DD594A;
  }
  #userOpen .rightBox  .train .trainLeft h1{
    /* border-left: calc(#{$scale} * 4px) solid #DD594A; */
    margin-left: calc(#{$scale} * 12px);
    height: calc(#{$scale} * 32px);
    line-height: calc(#{$scale} * 32px);
    font-weight: 500;
    color: #262626;
    font-size: calc(#{$scale} * 20px);
    font-family: PingFangSC-Medium, PingFang SC;
  }
  #userOpen .rightBox  .train .trainLeft ul{
    padding-left: calc(#{$scale} * 24px);
  }
  #userOpen .rightBox  .train .trainLeft li{
    font-size: calc(#{$scale} * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  #userOpen .rightBox .train  .trainRight{
    margin-top: calc(#{$scale} * 20px);
    float: right;
  }
  #userOpen .rightBox .train  .trainRight .custom-switch .custom-switch {
    width: calc(#{$scale} * 56px); /* 自定义开关的宽度 */
    height: calc(#{$scale} * 30px); /* 自定义开关的高度 */
  }
  #userOpen .rightBox .train  .trainRight .el-switch__core .el-switch__button {
    width: calc(#{$scale} * 26px); /* 自定义开关球的宽度 */
    height: calc(#{$scale} * 26px); /* 自定义开关球的高度 */
  }
</style>
